import { useState, useEffect, useContext } from 'react'
import { toPng } from '@intuiface/html-to-image'

import { PassContext } from "../../pass-context"

export default ({ show }) => {
  const { template, model, instanceData, scannerInstanceData } = useContext(PassContext)

  const [minature, setMinature] = useState(null)

  useEffect(() => {
    var node = document.getElementById('appleFront')

    node.classList.add("preview")

    toPng(node,{cacheBust:true}) // CacheBust add timestamp to URL. This causes new request from server. Without this browser stops request for image from cache, with CORS error 
      .then(function (dataUrl) {
        setMinature(dataUrl)
        node.classList.remove("preview")
      })
      .catch(function (error) {
        console.error('oops, something went wrong!', error);
      })
  },[template, model, instanceData, scannerInstanceData])

  if (show) {
    return (
      <div className="front-minature">
        <div className="minature">
          <img src={minature} />
        </div>
      </div>
    )
  }
}